import React from "react";
import PropTypes from "prop-types";
import config from "config/config.js";

import "assets/scss/material-dashboard-pro-react/plugins/_plugin-react-datepicker.css";
import styles from "assets/jss/material-dashboard-pro-react/views/buttonsStyle.js";
import privacyPolicyHtml from "util/privacyPolicyHtml";

import { cardTitle } from "assets/jss/material-dashboard-pro-react.js";

Object.assign(styles, {
  cardIconTitle: {
    ...cardTitle,
    marginTop: "15px",
    marginBottom: "0px"
  },
  restaurantName: {
    textAlign: "center"
  }
});

export default function PolicyPrivacy(props) {
  return (
    <div className="main-banner-home" style={{ backgroundColor: "white" }}>
      <div
        style={{
          backgroundColor: "white",
          padding: "30px",
          color: "rgba(74,74,74,1)"
        }}
      >
        <div style={{ padding: "30px" }}>
          <div
            style={{ fontSize: "13px", fontFamily: "ArchivoNarrow-Regular" }}
          >
            NOTE LEGALI
          </div>
          <h1>PRIVACY POLICY</h1>
        </div>
        <div
          style={{ fontSize: "13px", fontFamily: "ArchivoNarrow-Regular" }}
        ></div>
      </div>
      <div
        style={{
          fontSize: "15px",
          fontFamily: "ArchivoNarrow-Regular",
          backgroundColor: "white",
          color: "rgba(74,74,74,1)",
          width: "calc(100% - 40px)",
          maxWidth: "1200px",
          margin: "auto",
          padding: "20px"
        }}
      >
        {privacyPolicyHtml()}
      </div>
    </div>
  );
}
PolicyPrivacy.propTypes = {
  updateCity: PropTypes.func.isRequired,
  city: PropTypes.object.isRequired
};
